import "./dashboard.css";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/userContext";
import axios from "axios";
import Loader from "../../components/loader/Loader";
import { PostItem } from '../../components/posts/PostItem'
import { Deletepost } from "../deletepost/Deletepost";

export const Dashboard = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  interface Post {
    _id: any;
    id: number;
    thumbnail: string;
    title: string;
  }

  const { currentUser } = useContext(UserContext);
  const navigate = useNavigate();
  const token = currentUser?.token;

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token, navigate]);

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/posts/users/${id}`,
          {
            withCredentials: true,
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setPosts(response.data);
      } catch (error) {
        console.error(error);
      }
      setIsLoading(false);
    };
    fetchPosts();
  }, [id, token]);

  if (isLoading) {
    return <Loader />;
  }
  
  const shortenTitle = (title: string) => {
    return title.length > 25 ? `${title.substr(0, 25)}...` : title;
  };

  return (
    <section className="dashboard">
      {posts.length ? (
        <div className="container dashboard__container">
          {posts.map((post) => (
            <article key={post._id} className="dashboard__post">
              <div className="dashboard__post-info">
                <div className="dashboard__post-thumbnail">
                  <img className="thumbnails__img"
                    src={`${post.thumbnail}`}
                    alt={`${post.title}`}
                  />
                </div>
                <h5>{shortenTitle(post.title)}</h5>
              </div>
              <div className="dashboard__post-actions">
                <Link to={`/posts/${post._id}`} className="btn sm">
                  View
                </Link>
                <Link to={`/posts/${post._id}/edit`} className="btn sm primary">
                  Edit
                </Link>
                <Deletepost postId={post._id}/>
              </div>
            </article>
          ))}
        </div>
      ) : (
        <h2 className="center">You have no posts yet.</h2>
      )}
    </section>
  );
};
